"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceMirrors = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRenderer_1 = require("../render/CardRenderer");
class SpaceMirrors extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SPACE_MIRRORS,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.SPACE],
            cost: 3,
            metadata: {
                cardNumber: '076',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 7 M€ to increase your energy production 1 step.', (eb) => {
                        eb.megacredits(7).startAction.production((pb) => pb.energy(1));
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.canAfford(7);
    }
    action(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 7, { title: 'Select how to pay for action' }));
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return undefined;
    }
}
exports.SpaceMirrors = SpaceMirrors;
//# sourceMappingURL=SpaceMirrors.js.map